import { render, staticRenderFns } from "./BcSearchMenu.vue?vue&type=template&id=ac86515a"
import script from "./BcSearchMenu.vue?vue&type=script&lang=js"
export * from "./BcSearchMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports